import { useState } from 'react'
// Server-side counts - no longer need client-side computation

const DEFAULT_META = 42

const AREAS = [
  { id: 'overdue', label: 'ATRASADOS', shortLabel: 'ATR', color: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300', activeColor: 'bg-gradient-to-r from-red-500 to-red-600 text-white', badgeColor: 'bg-red-600', activeRing: 'ring-red-300 dark:ring-red-500/50', activeShadow: 'shadow-red-500/60' },
  { id: 'yesterday', label: 'AYER', shortLabel: 'AYR', color: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300', activeColor: 'bg-gradient-to-r from-amber-500 to-amber-600 text-white', badgeColor: 'bg-amber-600', activeRing: 'ring-amber-300 dark:ring-amber-500/50', activeShadow: 'shadow-amber-500/60' },
  { id: 'today', label: 'HOY', shortLabel: 'HOY', color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300', activeColor: 'bg-gradient-to-r from-blue-500 to-blue-600 text-white', badgeColor: 'bg-blue-600', activeRing: 'ring-blue-300 dark:ring-blue-500/50', activeShadow: 'shadow-blue-500/60' },
  { id: 'tomorrow', label: 'MA\u00d1ANA', shortLabel: 'MA\u00d1', color: 'bg-sky-100 dark:bg-sky-900/30 text-sky-700 dark:text-sky-300', activeColor: 'bg-gradient-to-r from-sky-500 to-sky-600 text-white', badgeColor: 'bg-sky-600', activeRing: 'ring-sky-300 dark:ring-sky-500/50', activeShadow: 'shadow-sky-500/60' },
  { id: 'future', label: 'FUTUROS', shortLabel: 'FUT', color: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300', activeColor: 'bg-gradient-to-r from-green-500 to-green-600 text-white', badgeColor: 'bg-green-600', activeRing: 'ring-green-300 dark:ring-green-500/50', activeShadow: 'shadow-green-500/60' },
  { id: 'all_mine', label: 'TODOS MIOS', shortLabel: 'MIOS', color: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300', activeColor: 'bg-gradient-to-r from-indigo-500 to-indigo-600 text-white', badgeColor: 'bg-indigo-600', activeRing: 'ring-indigo-300 dark:ring-indigo-500/50', activeShadow: 'shadow-indigo-500/60' },
  { id: 'activos', label: 'ACTIVOS', shortLabel: 'ACT', color: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300', activeColor: 'bg-gradient-to-r from-purple-500 to-fuchsia-600 text-white', badgeColor: 'bg-purple-600', activeRing: 'ring-purple-300 dark:ring-purple-500/50', activeShadow: 'shadow-purple-500/60' },
  { id: 'discarded', label: 'DESCARTADOS', shortLabel: 'DESC', color: 'bg-gray-200 dark:bg-slate-700 text-gray-600 dark:text-gray-300', activeColor: 'bg-gradient-to-r from-gray-500 to-slate-600 text-white', badgeColor: 'bg-gray-600', activeRing: 'ring-gray-300 dark:ring-slate-500/50', activeShadow: 'shadow-gray-500/60' },
  { id: 'sold', label: 'VENDIDOS', shortLabel: 'VEN', color: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300', activeColor: 'bg-gradient-to-r from-emerald-500 to-green-600 text-white', badgeColor: 'bg-emerald-600', activeRing: 'ring-emerald-300 dark:ring-emerald-500/50', activeShadow: 'shadow-emerald-500/60' },
  { id: 'publicidad', label: 'PUBLICIDAD', shortLabel: 'PUB', color: 'bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300', activeColor: 'bg-gradient-to-r from-pink-500 to-fuchsia-600 text-white', badgeColor: 'bg-pink-600', activeRing: 'ring-pink-300 dark:ring-pink-500/50', activeShadow: 'shadow-pink-500/60' },
]

export default function WorkAreaPills({ counts: serverCounts, activeArea, onAreaChange, agentPhone, filterActive = false }) {
  const metaKey = `crm_work_meta_${agentPhone}`
  const [meta, setMeta] = useState(() => {
    const saved = localStorage.getItem(metaKey)
    return saved ? parseInt(saved, 10) : DEFAULT_META
  })
  const [editingMeta, setEditingMeta] = useState(false)

  const counts = serverCounts || { overdue: 0, yesterday: 0, today: 0, tomorrow: 0, future: 0, all_mine: 0, activos: 0, discarded: 0, sold: 0, publicidad: 0 }

  const handleMetaSave = (val) => {
    const num = Math.max(1, parseInt(val, 10) || DEFAULT_META)
    setMeta(num)
    localStorage.setItem(metaKey, num.toString())
    setEditingMeta(false)
  }

  const todayCount = counts.today
  const metaPercent = Math.min(100, Math.round((todayCount / meta) * 100))

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-1.5 flex-wrap">
        {AREAS.map(area => {
          const isActive = activeArea === area.id && !filterActive
          const count = counts[area.id]
          return (
            <button
              key={area.id}
              onClick={() => onAreaChange(isActive ? null : area.id)}
              className={`
                px-2.5 py-1 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap
                ${isActive
                  ? area.activeColor + ' shadow-2xl ' + area.activeShadow + ' ring-2 ring-offset-2 ring-offset-white dark:ring-offset-slate-900 ' + area.activeRing + ' workarea-active font-bold'
                  : area.color + ' hover:opacity-80 hover:scale-105 shadow-sm'}
              `}
            >
              <span className="hidden sm:inline">{area.label}</span>
              <span className="sm:hidden">{area.shortLabel}</span>
              {' '}
              {(() => {
                const badgeBase = 'inline-flex items-center justify-center h-[22px] px-1.5 rounded-full text-[11px] font-bold shadow-sm';
                // Badge activo: fondo oscuro + texto blanco (alto contraste sobre el gradient brillante del boton activo).
                // Antes usabamos bg-white pero en dark mode quedaba confuso. Slate-800 funciona bien en ambos temas.
                const badgeActive = 'bg-slate-800 !text-white ring-1 ring-white/40';
                // Badge inactivo: blanco/texto-oscuro en light, slate-800/blanco en dark.
                // Sin override dark explicito, el bg-white quedaba apagado sobre el pill oscuro y los digitos no se distinguian.
                const badgeInactive = 'bg-white !text-gray-900 dark:!bg-slate-800 dark:!text-white border border-gray-300 dark:border-slate-500';
                const cls = `${badgeBase} ${isActive ? badgeActive : badgeInactive}`;
                if (area.id === 'today') {
                  return <span className={`${cls} min-w-[40px]`}>{count}/{meta}</span>;
                }
                return <span className={`${cls} min-w-[22px]`}>{count}</span>;
              })()}
            </button>
          )
        })}
        {activeArea && (
          <button
            onClick={() => onAreaChange(null)}
            className="px-2 py-1 text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            title="Quitar filtro"
          >
            x
          </button>
        )}
      </div>
      {(activeArea === 'today' || !activeArea) && (
        <div className="flex items-center gap-2">
          <div className="flex-1 h-1.5 bg-gray-200 dark:bg-slate-700 rounded-full overflow-hidden">
            <div
              className={`h-full rounded-full transition-all duration-300 ${
                metaPercent >= 100 ? 'bg-green-500' : metaPercent >= 75 ? 'bg-blue-500' : metaPercent >= 50 ? 'bg-amber-500' : 'bg-red-400'
              }`}
              style={{ width: `${metaPercent}%` }}
            />
          </div>
          {editingMeta ? (
            <input
              type="number"
              defaultValue={meta}
              onBlur={(e) => handleMetaSave(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleMetaSave(e.target.value)}
              autoFocus
              className="w-12 text-[10px] text-center border border-gray-300 dark:border-slate-600 rounded bg-white dark:bg-slate-800 text-gray-700 dark:text-gray-300"
            />
          ) : (
            <span
              onClick={() => setEditingMeta(true)}
              className="text-[10px] text-gray-400 dark:text-gray-500 cursor-pointer hover:text-gray-600 dark:hover:text-gray-300 whitespace-nowrap"
              title="Click para editar meta"
            >
              {todayCount}/{meta} meta
            </span>
          )}
        </div>
      )}
    </div>
  )
}
